<template>
	<div>
		<div class="luminance-page">
			<div class="bg"></div>
			<time-num></time-num>
			<div class="luminanceTop">
				<div class="top">
					<img src="./../../assets/microscope/selectIcon.png" alt="" />当前倍镜
				</div>
				<div class="bottom">
					<div class="left">
						<div class="multiplier">
							<img src="./../../assets/microscope/multiplierIcon.png" alt="" srcset="" />
						</div>
						<div class="text">10x</div>
						<div class="solid"></div>
					</div>
					<div class="right">
						<div class="text">当前图片为10倍镜视野</div>
						<div class="text">请调整亮度</div>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="slideImgBox" v-if="currentItem">
					<img class="slideImg" :style="{
              opacity: currentNum / 10,
              filter: `alpha(${currentNum / 10})`,
            }" :src="currentItem.lowImage1" alt="" />
				</div>

				<div class="flex">
					<div @click="handleUpper" class="upper">
						<div class="imgBox">
							<img src="./../../assets/microscope/upperIcon.png" alt="" />
						</div>
						<div class="text">提高亮度</div>
					</div>
					<div @click="handleBelow" class="prev">
						<div class="imgBox">
							<img src="./../../assets/microscope/belowIcon.png" alt="" />
						</div>
						<div class="text">降低亮度</div>
					</div>
				</div>
			</div>
			<div class="footer">
				<div @click="handleReset" class="left">
					<img src="./../../assets/microscope/prevIcon.png" alt="" />
					重置
				</div>
				<!-- <div class="nextquestionactive" @click="$router.replace('/microscope/slide')">
					<img class="next1" src="./../../assets/home/previous.png"></img>上一步
				</div> -->
				<div @click="handleShow" class="right">
					<img src="./../../assets/microscope/answerIcon.png" alt="" />
					下一步
				</div>
			</div>
			<div class="mask" v-if="isShow"></div>
			<div class="dialog" v-if="isShow">
				<div class="title">提示！</div>
				<div class="text mt100">亮度一经确认，</div>
				<div class="text">后续读片阶段中将无法再做调整。</div>
				<div class="flex">
					<div @click="handleClose" class="btn">再做调整</div>
					<div @click="handleNext" class="btn">确定亮度</div>
				</div>
			</div>
		</div>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import MiXin from "../mixins/index";
	import {
		mapState,
		mapMutations
	} from "vuex";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		name: "Home2026",
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				isShow: false,
				currentItem: null,
				currentNum: null,
			};
		},
		computed: {
			...mapState("microscope", ["num", "slideType", "slidePaper", "examDetailId", "detail1", "detail2"]),
		},
		mounted() {
			this.currentItem = this.slidePaper[this.slideType];
			this.currentNum = this.num;
		},
		watch: {
			// 调节调度
			currentNum: {
				handler(val) {
					this.handleMicroscope({
						key: "num",
						value: val,
					});
				},
			},
		},
		methods: {
			...mapMutations("microscope", ["handleMicroscope"]),
			// 增加亮度
			handleUpper() {
				if (this.currentNum !== 10) {
					this.currentNum += 1;
				}
			},

			// 降低亮度
			handleBelow() {
				if (this.currentNum > 1) {
					this.currentNum -= 1;
				}
			},

			// 重置亮度
			handleReset() {
				this.currentNum = 6;
			},

			// 打开确认弹框
			handleShow() {
				this.isShow = true;
			},

			// 关闭确认弹框
			handleClose() {
				this.isShow = false;
			},

			// 去低倍镜
			handleNext() {
				let backendAnswers = {
					paper1Id: this.slidePaper[0].id,
					paper2Id: this.slidePaper[1].id,
					detail1: this.detail1,
					detail2: this.detail2,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(backendAnswers),
					paperId: this.slideType,
					questionId: '0',
					answers: JSON.stringify({
						detail1: this.detail1,
						detail2: this.detail2
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace("/microscope/lowPowe");
				});

			},
		},
	};
</script>

<style lang="less" scoped>
	.luminance-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;

		.bg {
			height: 5px;
		}

		.luminanceTop {
			width: 653px;
			height: 282px;
			background: rgba(255, 255, 255, 0.85);
			border: 2px solid #ffffff;
			border-radius: 60px;
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			margin: 0 auto;

			.top {
				margin-left: 48px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				margin-top: 28px;

				img {
					width: 30px;
					vertical-align: middle;
					margin-right: 24px;
				}
			}

			.bottom {
				margin-left: 75px;
				margin-top: 15px;
				display: flex;

				.left {
					.multiplier {
						width: 134px;
						height: 134px;
						background: rgba(171, 59, 145, 0.2);
						border-radius: 50%;
						position: relative;

						img {
							position: absolute;
							top: 20px;
							left: 40px;
							display: block;
							width: 55px;
							margin: 0 auto;
						}
					}

					.text {
						font-size: 25px;
						font-family: HarmonyOS Sans SC;
						font-weight: 500;
						color: #333333;
						text-align: center;
						margin-top: 10px;
					}

					.solid {
						width: 134px;
						height: 5px;
						background: #ab3b91;
						border-radius: 2px;
						margin-top: 12px;
					}
				}

				.right {
					margin-left: 64px;
					margin-top: 10px;

					.text {
						font-size: 30px;
						font-family: HarmonyOS Sans SC;
						font-weight: 500;
						color: #4c4c4c;
						line-height: 50px;
						text-align: center;
					}
				}
			}
		}

		.content {
			width: 653px;
			min-height: calc(100vh - 490px);
			background: rgba(255, 255, 255, 0.3);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;
			margin: 0 auto;
			padding-top: 1px;
			margin-top: 24px;
			margin-bottom: 140px;

			.slideImgBox {
				background: #000000;
				width: 610px;
				margin: 0 auto;
				margin-top: 20px;
				border-radius: 60px;

				.slideImg {
					display: block;
					width: 610px;
					margin: 0 auto;
					margin-top: 20px;
					border-radius: 60px;
				}
			}

			.flex {
				display: flex;
				margin-top: 60px;

				.upper {
					margin-left: 136px;

					.imgBox {
						width: 90px;
						height: 90px;
						background: #ab3b91;
						border-radius: 50%;
						margin-left: 4px;

						img {
							display: block;
							width: 38px;
							margin: 0 auto;
							padding-top: 20px;
						}
					}

					.text {
						font-size: 25px;
						font-family: HarmonyOS Sans SC;
						font-weight: 500;
						color: #ffffff;
						margin-top: 18px;
					}
				}

				.prev {
					margin-left: 180px;

					.imgBox {
						width: 90px;
						height: 90px;
						background: #ab3b91;
						border-radius: 50%;
						margin-left: 4px;

						img {
							display: block;
							width: 38px;
							margin: 0 auto;
							padding-top: 20px;
						}
					}

					.text {
						font-size: 25px;
						font-family: HarmonyOS Sans SC;
						font-weight: 500;
						color: #ffffff;
						margin-top: 18px;
					}
				}
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 143px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			border-radius: 60px 60px 0px 0px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-around;

			.left {
				width: 210px;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;

				img {
					width: 35px;
					margin-left: 30px;
					margin-right: 25px;
					vertical-align: middle;
				}
			}

			.right {
				width: 230px;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;
				text-align: center;

				img {
					width: 35px;
					margin-right: 10px;
					vertical-align: middle;
				}
			}
		}

		.mask {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			background: rgba(255, 255, 255, 0.8);
		}

		.dialog {
			width: 665px;
			height: 642px;
			position: fixed;
			z-index: 2;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
			background: #ffffff;
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;

			.title {
				height: 60px;
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
				text-align: center;
				margin-top: 100px;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				text-align: center;
			}

			.mt100 {
				margin-top: 100px;
			}

			.flex {
				display: flex;
				padding: 120px 50px 0 50px;

				.btn {
					width: 260px;
					height: 80px;
					line-height: 80px;
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					border-radius: 40px;

					background: linear-gradient(132.74deg,
							rgba(0, 187, 177, 1) 0%,
							rgba(0, 86, 140, 1) 74.31%,
							rgba(171, 59, 127, 1) 100%);
				}

				.btn:nth-child(2) {
					margin-left: auto;
				}
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 218px;
		height: 88px;
		border-radius: 100px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>